import axios from 'axios'
import VueJwtDecode from 'vue-jwt-decode'

const state = {
	access_token: '',
	expires_in: 0,
	user: {
		id: 0,
		full_name: '',
		username: '',
		email: '',
		role: '',
		permissions: []
	}
}


const getters = {
	getAccessToken(state) {
		return state.access_token
	},
	user(state) {
		return state.user
	},
	getExpiresIn(state) {
		return state.expires_in
	},
}


const mutations = {
	login(state, data) {
		localStorage.setItem('media-token', JSON.stringify({
			access_token: data.access_token,
			expires_in: new Date().getTime() + data.expires_in * 1000
		}))
		this.commit('initialize')
	},
	refreshToken(state, data) {

	},
	logout(state) {
		localStorage.removeItem('media-token')
		localStorage.removeItem('media-locale')
		state.access_token = ''
		state.expires_in = 0
		state.user.id = 0
		state.user.full_name = ''
		state.user.username = ''
		state.user.email = ''
		state.user.role = ''
		state.user.permissions = []

	},
	initialize(state) {
		if (localStorage.getItem('media-token')) {
			let token = JSON.parse(localStorage.getItem('media-token'))

			if (token.expires_in <= new Date().getTime()) {
				localStorage.removeItem('media-token')
				return
			}

			const payload = VueJwtDecode.decode(token.access_token)

			state.access_token = token.access_token
			state.expires_in = token.expires_in
			state.user.id = payload.sub
			state.user.full_name = payload.full_name
			state.user.username = payload.username
			state.user.email = payload.email
			state.user.role = payload.role
			state.user.permissions = payload.permissions

		}
	}
}

const actions = {

}

export default {
	state,
	getters,
	actions,
	mutations
}